import { paidSearchTypes } from "app/common/keyword-research/search-competitors/searchTypeConsts";

import { Connected } from "./KeywordCompetitors";

export const KeywordCompetitorsPaidPage = (props) => {
    const tabMetaData = {
        isPaid: true,
        tableApi: `/widgetApi/SearchCompetitors/SearchCompetitorsPaid/Table`,
        excelApi: `/widgetApi/SearchCompetitors/SearchCompetitorsPaid/Excel`,
        domainsCountApi: `/widgetApi/SearchCompetitors/SearchCompetitorsPaid/DomainsCounts`,
        i18nPrefix: `analysis.competitors.search.paid.table`,
        metric: `KeywordCompetitorsPaidTable`,
        tableSelectionTracking: `Keyword Competitors Paid`,
        tableSelectionKey: "KeywordCompetitorsPaidTable",
        searchTypeFilterPlaceholder: "analysis.competitors.search.paid.table.filters.searchtype",
        searchTypeParam: "paidSearchType",
        searchTypes: paidSearchTypes,
        title: "analysis.competitors.search.paid.title",
    };
    return (
        <Connected
            tabMetaData={tabMetaData}
            {...props}
        />
    );
};
